import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const DeliveryIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    fill="none"
    height="24"
    optimizationId="tama-delivery"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      d="M11.242 17.88a2.03 2.03 0 0 1-1.53-.476 1.998 1.998 0 0 1-.738-1.413l-1.39.121-.67-7.586c-.033-.38.074-.716.323-1.01.248-.293.564-.457.946-.49l9.733-.845.244 2.759 2.086-.181 2.329 2.577.304 3.449-1.39.12c.05.575-.11 1.081-.48 1.519-.37.437-.845.681-1.424.731a2.03 2.03 0 0 1-1.53-.475 1.998 1.998 0 0 1-.738-1.413l-4.172.362c.05.575-.109 1.081-.479 1.519-.37.437-.845.681-1.424.731Zm-.122-1.38a.678.678 0 0 0 .635-.75.68.68 0 0 0-.756-.63.678.678 0 0 0-.635.75.668.668 0 0 0 .243.474.68.68 0 0 0 .513.156Zm8.343-.724a.675.675 0 0 0 .478-.242.665.665 0 0 0 .157-.508.667.667 0 0 0-.244-.474.677.677 0 0 0-.512-.155.675.675 0 0 0-.478.241.664.664 0 0 0-.157.509.666.666 0 0 0 .244.473c.145.121.315.173.512.156Zm-1-3.388 2.956-.256-1.747-1.934-1.39.121.182 2.069Z"
      fill="#0C193A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.602 10.888a.5.5 0 0 1 .5-.5h.95a.5.5 0 1 1 0 1h-.95a.5.5 0 0 1-.5-.5ZM1.3 13.469a.5.5 0 0 1 .5-.5h2.253a.5.5 0 1 1 0 1H1.801a.5.5 0 0 1-.5-.5ZM0 16.05a.5.5 0 0 1 .5-.5h3.553a.5.5 0 1 1 0 1H.5a.5.5 0 0 1-.5-.5Z"
      fill="#0C193A"
    />
    <path
      d="m15.403 10.418-1.517-1.555a.443.443 0 0 0-.422-.12l-2.115.524a.438.438 0 0 0-.316.303l-.598 2.079a.434.434 0 0 0 .107.423l1.517 1.556c.11.111.271.156.423.118l2.115-.524a.437.437 0 0 0 .316-.303l.598-2.079a.434.434 0 0 0-.107-.422Z"
      fill="#fff"
    />
    <path
      d="m13.476 10.19-.409.904-.568-.983-.583.21-.568 1.972.658-.057.345-1.164.532 1.034.338-.029.545-1.205.13 1.47.597-.259-.161-1.817-.856-.076Z"
      fill="#0C193A"
    />
  </Svg>
));

DeliveryIcon.displayName = 'DeliveryIcon';
